<template>
  <div class="report">
    <div class="page-header-wrapper">
      <PageHeader title="Meeting Statistics"></PageHeader>
      <el-form class="filter-wrapper" label-width="60px">
        <el-col :span="6" v-role="[1, 2, 4]">
          <el-form-item label="Role" prop="role">
            <el-select v-model="form.role" placeholder="Please select Role" filterable @change="roleChange">
              <el-option v-for="(item, idx) in roleOptions" :key="idx" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-role="[1, 2, 4]">
          <el-form-item label="Team" label-width="55px">
            <el-select v-model="form.teamId" placeholder="Please select Team" filterable @change="teamChange">
              <el-option v-for="(item, idx) in teamOptions" :key="idx" :label="item.TeamName" :value="item.TeamID">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-role="[1, 2, 4]">
          <el-form-item label="User">
            <el-select v-model="form.user" placeholder="Please select User" filterable>
              <el-option v-for="(item, idx) in mlListOptions" :key="idx" :label="item.MLName" :value="item.MLID">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-role="[1, 2, 4]">
          <el-form-item label="Type" prop="type">
            <el-select v-model="form.typeId" placeholder="Please select type" :loading="typeLoading">
              <el-option v-for="item in typeOptions" :key="item.typeid" :label="item.typedescription" :value="item.typeid">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Year">
            <el-select v-model="form.year" placeholder="Please select year">
              <el-option v-for="item in yearsOptions" :key="item.Year" :label="item.Year" :value="item.Year">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Month">
            <el-select class="month-select" ref="monthSelect" v-model="form.month" placeholder="Please select month"
              multiple v-multiple-tip @change="monthSelectChange">
              <el-option v-for="item in monthOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <div class="query-action">
          <el-button type="primary" icon="el-icon-search" @click="getTableData()" :disabled="queryable">
            Query
          </el-button>
          <el-button type="primary" icon="iconfont icon-export" @click="getTableData(true)" :disabled="exportable"
            :loading="exporting">
            Export
          </el-button>
        </div>
      </el-form>
    </div>
    <div class="info-wrapper">
      <div class="title">Account</div>
      <div class="detial-wrapper">
        <span class="detial">User: {{ accountInfo.User }}</span>
        <span class="detial">Meeting: {{ accountInfo.Meeting }}</span>
        <span class="detial">HCP: {{ accountInfo.HCP }}</span>
        <span class="detial">Duration≥15mins: {{ accountInfo.Duration15mins }}</span>
        <span class="detial">Average duration: {{ accountInfo.AverageDruation }} mins</span>
        <span class="detial">
          <div class="grid-content bg-purple-light"></div>
        </span>
      </div>
    </div>
    <div class="table-wrapper">
      <el-table :data="tableData" v-loading="tableLoading" element-loading-text="Loading...">
        <el-table-column prop="name" label="User" width="125" />
        <el-table-column prop="description" label="Role" width="125" />
        <el-table-column prop="title" label="Meeting Name" min-width="130" />
        <el-table-column prop="meetingcode" label="Meeting ID" min-width="115" />
        <el-table-column prop="se_names" label="HCP" width="125" />
        <el-table-column prop="type_descriptions" label="Type" width="125" />
        <el-table-column prop="attendance" label="Attendance" width="125" />
        <el-table-column prop="duration" label="Duration(mins)" width="125" />
        <el-table-column prop="Feedback" label="Feedback" width="125" v-if="[1, 2, 4, 13].includes(role)" align="center">
          <template slot-scope="{ row }" prop="StatusDesc">
            <!-- //vCE的时候显示 v-if="row.Type.indexOf('vCE')>-1"-->
            <i class="el-icon-view" v-show="row.type_descriptions && row.description.indexOf('vMSL')>-1"  style="cursor:pointer"  @click="handleRate(row)" ></i>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- rate-dialog -->
    <el-dialog title="View Feedback" :visible.sync="showRateDialog" width="75%" append-to-body destroy-on-close
      custom-class="rateDialog">
      <el-table size="mini" v-loading="tableLoadingRate" element-loading-text="Loading..." :data="tableDataRate"
        ref="SeTable">
        <el-table-column prop="SEName" :label="isVMSL ? 'vCE Name' : 'HCP Name'" min-width="50" />
        <el-table-column prop="Professional" label="对医学人员解答您学术问题的专业能力是否满意？" min-width="100">
          <template slot-scope="{ row }">
            {{ row.Professional==null?'':(row.Professional == 1 ? '满意' : '不满意') }}
          </template>
        </el-table-column>
        <el-table-column prop="Information" label="对医学人员为您提供的学术信息、资料是否满意？" min-width="100">
          <template slot-scope="{ row }">
            {{ row.Information==null?'':(row.Information == 1 ? '满意' : '不满意') }}
          </template>
        </el-table-column>
        <el-table-column prop="Timeliness" label="对医学人员回应您学术需求的及时性是否满意？" min-width="100">
          <template slot-scope="{ row }">
            {{ row.Timeliness==null?'':(row.Timeliness == 1 ? '满意' : '不满意') }}
          </template>
        </el-table-column>
        <el-table-column prop="Convenience" label="对系统操作的便利度是否满意？" min-width="100">
          <template slot-scope="{ row }">
            {{ row.Convenience==null?'':(row.Convenience == 1 ? '满意' : '不满意') }}
          </template>
        </el-table-column>
        <el-table-column width="150" prop="Feedbackon" label="评价时间"/>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import downloadjs from "downloadjs";
import labelMixin from "@/mixins/label-mixin";
import { RoleCode } from "@/utils/role-constant";
export default {
  name: "SE-Activity-Department-View",
  mixins: [labelMixin],
  data() {
    return {
      tableLoading: false,
      tableData: [],
      exporting: false,
      form: {
        user:'',
        role: "",
        teamId: "",
        year: moment().year(),
        month: [moment().month() + 1],
        typeId: "",
      },
      accountInfo: {
        User: 0,
        Meeting: 0,
        HCP: 0,
        Duration15mins: 0,
        AverageDruation: 0
      },
      roleList: [],
      taList: [],
      teamList: [],
      otherList: null,
      monthOptions: [
        {
          label: "All",
          value: "",
        },
      ],
      queryable: true,
      exportable: true,
      // charts as follow:
      loadingOption: {
        text: "loading...",
        color: "#d52b1e",
        lineWidth: 2,
      },
      noOfPushHitsCommentsChart: null,
      noOfPushHitsCommentsChartDataEmpty: false,
      interactionChart: null,
      interactionChartDataEmpty: false,
      avgPageviewsChart: null,
      avgPageviewsChartDataEmpty: false,
      resizeListener: null,
      mlList: [],
      tableLoadingRate: true,
      tableDataRate: [],
      showRateDialog: false,
      typeOptions:[{
              typedescription:'All',
              typeid:''
            }]
    };
  },
  created() {
    this.getData();
    this.getType()
    this.bus.$on("refresh", ({ name }) => {
       console.log(name)
      if (name=='Meeting-Statistics') {
        this.getData();
      }
    });
    this.bus.$on("onSideMenuCollapse", () => {
    });
    for (let i = 1; i <= 12; i++) {
      this.monthOptions.push({
        label: i,
        value: i,
      });
    }
  },
  computed: {
    isVMSL() {
      return this.$store.state.role === RoleCode.VMSL
    },
    role() {
      return this.$store.state.role;
    },
    filterSpan() {
      return this.role === 1 ? 6 : 5;
    },
    isShowCharts() {
      return (
        this.role === RoleCode.Supervisor ||
        this.role === RoleCode.CRPLeader ||
        this.role === RoleCode.CVEOLeader ||
        this.role === RoleCode.SciComLeader ||
        this.role === RoleCode.ClinTransLeader
      );
    },
    teamName() {
      let team = this.teamList.find((item) => item.TeamID === this.form.teamId);
      return team ? team.TeamName : "";
    },
    yearsOptions() {
      return this.otherList ? this.otherList.year : [];
    },
    roleOptions() {
      return [{ value: "", name: "All" }].concat(this.roleList);
    },
    teamOptions() {
      return  [{ TeamName: "All", TeamID: "", RoleName: "" }].concat(this.teamList)
    },
    mlName() {
      let ml = this.mlListOptions.find((item) => item.MLID === this.form.mlId);
      return ml ? ml.MLName : "";
    },
    mlListOptions() {
      return this.mlList.filter((i) => {
        return (
          ((this.form.teamId != ""
            ? i.TeamID === this.form.teamId
            : this.teamOptions.some((j) => j.TeamID === i.TeamID)) && (
              this.form.role != ""
            ? i.RoleName === this.form.role
            : this.roleOptions.some((j) => j.value === i.RoleName))) ||
          i.MLName === "All"
        );
      });
    },
    barWidth() {
      return document.body.clientHeight / 35;
    },
  },
  mounted() {
  },
  beforeDestroy() {
  },
  activated() {
  },
  methods: {
    getType(){
      this.typeLoading = true;
      this.axios
        .get(`/sys/getHcpType`)
        .then(({ code, data, msg }) => {
          if (200 === code) {
            this.typeOptions=[{
              typedescription:'All',
              typeid:''
            },
            ...data]
            this.form.typeId = ''
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
          this.typeLoading = false;
        })
        .catch(() => {
          this.typeLoading = false;
        });
    },
    roleChange() {
      this.form.teamId = "";
    },
    teamChange() {
      this.form.user = "";
    },
    monthSelectChange(value) {
      const filter = (val) => val === "";
      const index = value.findIndex(filter);
      const isAll = value.some(filter);
      this.form.month = value.filter((val) => {
        return isAll && (index !== 0 || value.length === 1)
          ? val === ""
          : val !== "";
      });
      if (value.length === 0) {
        this.form.month = [""];
      }
    },
    hideLoadings() {
      this.noOfPushHitsCommentsChart &&
        this.noOfPushHitsCommentsChart.hideLoading();
      this.interactionChart && this.interactionChart.hideLoading();
      this.avgPageviewsChart && this.avgPageviewsChart.hideLoading();
    },
    getTableData(exportable = false) {
      this.tableLoading = !exportable;
      this.exporting = exportable;
      const month = this.form.month.filter((value) => value !== "");
      let params = {
        ...this.form,
        month: month.toString(),
        exportable: exportable ? 1 : 0,
      };
      if (exportable) {
        Object.assign(params, {
          teamName: this.teamName,
          mlName: this.mlName,
        });
      }
      let apiUrl = exportable?'meetingStatistics/export':'meetingStatistics/getList'
      this.axios
        .get(apiUrl, {
          params: params,
          responseType: exportable ? "blob" : "json",
        })
        .then(({ code, data, msg }) => {
          if (exportable) {
            downloadjs(data.file, data.fileName, "application/vnd.ms-excel");
            this.exporting = false;
          } else {
            if (200 === code) {
              this.accountInfo = data.account
              this.tableData = data.statistics;
              console.log(this.tableData)
              this.tableLoading = false;
            } else {
              this.$message.error(msg);
            }
          }
        })
        .catch(() => {
          this.exporting = false;
        });
    },
    getData() {
      Promise.all([
        this.axios.get("meetingStatistics/teamList"),
        this.axios.get(`meetingStatistics/roleList`),
        this.axios.get("meetingStatistics/mlList"),
        this.axios.get(`analytics/otherList`),
      ]).then((res) => {
        this.getTeamList(res[0]);
        this.getRoleList(res[1]);
        this.getMlList(res[2]);
        this.getOtherList(res[3]);
        this.getTableData();
        this.queryable = false;
        this.exportable = false;
      });
    },
    getRoleList({ code, data, msg }) {
      if (200 === code) {
        this.roleList = data;
        if (
          this.role === RoleCode.Supervisor ||
          this.role === RoleCode.TALead
        ) {
          const { value } = data[0] || { value: "" };
          this.form.role = value;
        } else {
          const roleName = this.$store.state.userInfo.roleName;
          const { value } = this.roleList.find(
            ({ value }) => roleName.indexOf(value) > -1
          ) || { value: "" };
          this.form.role = value;
        }
      } else {
        this.$message.error(msg);
      }
    },
    getTeamList({ code, data, msg }) {
      if (200 === code) {
        this.teamList = data;
        if (
          this.role == RoleCode.Supervisor ||
          this.role == RoleCode.CRPLeader ||
          this.role == RoleCode.CVEOLeader ||
          this.role == RoleCode.SciComLeader ||
          this.role == RoleCode.ClinTransLeader
        ) {
          this.form.teamId = data.length > 0 ? data[0].TeamID : "";
        }
      } else {
        this.$message.error(msg);
      }
    },
    getOtherList({ code, data, msg }) {
      if (200 === code) {
        this.otherList = data;
      } else {
        this.$message.error(msg);
      }
    },
    getMlList({ code, data, msg }) {
      if (200 === code) {
        this.mlList = [
          {
            MLName: "All",
            MLID: "",
            TeamID: "",
          },
        ].concat(data);
      } else {
        this.$message.error(msg);
      }
    },
    handleRate(row) {
      this.showRateDialog = true;
      this.getRateList(row)
    },
    handleSizeChangeRate(pageSize) {
      this.pageSizeRate = pageSize;
      this.getRateList();
    },
    handleCurrentChangeRate(currentPage) {
      this.currentPageRate = currentPage;
      this.getRateList();
    },
    getRateList(row) {
      this.tableLoadingRate = true;
      // let params = {
      //   pageSize: this.pageSizeRate,
      //   page: this.currentPageRate,
      // };

      this.axios
        .get(`/meeting/getMeetingRate?meetingId=${row.meetingid}`)
        .then(({ code, data, msg }) => {
          if (200 === code) {
            this.tableDataRate = data;
            // this.totalRate = data.tot?al;
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
          this.tableLoadingRate = false;
        })
        .catch(() => {
          this.tableLoadingRate = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.filter-wrapper {
  padding-top: 10px;
  display: flex;
  align-items: flex-start;
  justify-content: inherit !important;
  flex-wrap: wrap;
  padding: 0 !important;

  .el-form-item {
    margin-bottom: 10px !important;

    .el-select {
      width: 100%;
    }
  }

  .query-action {
    flex: 1;
    margin-bottom: 10px;
    margin-left: 10px;
    white-space: nowrap;
    text-align: right;
  }
}

.info-wrapper {
  .title {
    font-weight: bold;
    font-size: 16px;
  }
}

.detial-wrapper {
  margin-left: 20px;
  margin-top: 10px;

  .detial {
    margin-right: 45px;
    display: inline-block;
  }
}
</style>
